import { useState, useEffect } from 'react';
import { collection, query, where, limit, getDocs } from 'firebase/firestore';
import { db } from '../../../firebase';

const Hero = () => {
  const [heroImage, setHeroImage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadHeroImage = async () => {
      try {
        // Query for active hero image
        const imagesRef = collection(db, 'gallery_images');
        const q = query(
          imagesRef,
          where('isActive', '==', true),
          where('landingSection', '==', 'hero'),
          limit(1)
        );
        
        const querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
          const doc = querySnapshot.docs[0];
          const data = doc.data();
          setHeroImage({
            url: data.url,
            alt: data.alt || data.title || 'Winnepocket Landscaping'
          });
        }
      } catch (err) {
        console.error('Error loading hero image:', err);
      } finally {
        setLoading(false);
      }
    };

    loadHeroImage();
  }, []);

  // Fallback image for when no hero image is assigned
  const fallbackImage = "/herobanner.webp";
  
  const backgroundImage = heroImage?.url || fallbackImage;
  const imageAlt = heroImage?.alt || "Professional Landscaping Services";

  return (
    <section 
      className="relative h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{ 
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${backgroundImage})` 
      }}
    >
      {/* Hidden image for SEO and accessibility */}
      <img 
        src={backgroundImage} 
        alt={imageAlt}
        className="sr-only"
        onError={(e) => {
          if (e.target.src !== fallbackImage) {
            e.target.src = fallbackImage;
          }
        }}
      />
      
      {/* Loading indicator */}
      {loading && (
        <div className="absolute top-4 right-4 bg-black bg-opacity-50 rounded-lg p-2">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white"></div>
        </div>
      )}
      
      {/* Hero Content */}
      <div className="container mx-auto px-4 text-center text-white">
        <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
          Transform Your
          <span className="block text-primary-600">Outdoor Space</span>
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed">
          Professional landscaping services that bring your vision to life. 
          From design to maintenance, we create beautiful outdoor spaces that last.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a 
            href="#contact" 
            className="bg-primary-600 hover:bg-red-700 text-white px-8 py-4 rounded-full text-lg font-semibold transition-colors shadow-lg hover:shadow-xl"
          >
            Get A Quote
          </a>
          <a 
            href="#services" 
            className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-full text-lg font-semibold transition-colors"
          >
            View Our Work
          </a>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;